import React, { useEffect, useContext, useCallback, useState } from "react";
import "./adminProfilePage.css";
import strings from "../../utils/property-file/adminProfilePage.json";
import Ripple from "../button/ripple";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from "react-router-dom";
import constants from "../../utils/constants";
import { useForm } from "react-hook-form";
import moment from "moment";
import { AdminFormContext } from '../adminFormContext'
import { ImageContext } from '../adminProfilePhotoContext';

export default function AdminProfilePage() {

    useEffect(() => {
        if (!location.state) {
            nav(constants.navigationLink.loginLink);
        }
    }, []);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const nav = useNavigate();
    const location = useLocation();
    const { adminFormData, setAdminFormData } = useContext(AdminFormContext);
    const { imageData, setImageData } = useContext(ImageContext);
    const [tempImg, setTempImg] = useState(imageData ? URL.createObjectURL(imageData) : null)
    const handleFormChange = (data) => {
      setAdminFormData((prevadminFormData) => ({ ...prevadminFormData, data}));
    };
    const addAdminProfile = (data) => {
        nav(constants.navigationLink.officeTimingLink, { state: true })
        handleFormChange (data);
    }
    const handleImageChange = useCallback((event) => {
        const file = event.target.files[0];
        if (file) {
            var fileName = file.name;
            let idxDot = fileName.lastIndexOf('.') + 1;
            let extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
            if (extFile === 'jpg' || extFile === 'jpeg' || extFile === 'png' || extFile === 'svg' || extFile === 'bmp') {
                if (file.size <= 10000000) {
                    setImageData(file);
                    setTempImg(URL.createObjectURL(file))
                } else {
                    toast.error(strings.fileSizeError, { toastId: 'error3' });
                    setImageData(null);
                    setTempImg(null);
                }
            } else {
                toast.error(strings.fileError, { toastId: 'error4' });
                setImageData(null);
                setTempImg(null);
                setTempImg(null);
            }
        } else {
            setImageData(null);
        }
    }, [setImageData]);

    return (
        <React.Fragment>
            <div>
                <div className="side-arrow"
                    onClick={() => {
                        nav(constants.navigationLink.companyRegLink, { state: true })
                    }}>
                    <i className="ri-arrow-left-line admin-side-arrow"></i>
                </div>
                <div className="parent-admin-container">
                    <div className="admin-progress">
                        <div className="admin-progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                    <div className="child-admin-container  mx-auto">
                        <form encType="multipart/form-data">
                            <label htmlFor="fileToUpload">
                                <div className="office-logo-container">
                                    {imageData ? (
                                        <img src={(tempImg)} className="admin-profile-picture" />
                                    ) : (
                                        <i className="ri-user-add-line" id="admin-logo" />
                                    )}
                                </div>
                                <input
                                    type="file"
                                    name="fileToUpload"
                                    id="fileToUpload"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                />
                            </label>
                        </form>
                        <div className="company-page-heading">
                            <h4 className="mt-4">
                                {strings.adminProfile}
                            </h4>
                            <p>{strings.adminPageDesc}
                                <strong> {strings.step2}</strong></p>
                        </div>
                        <div className="grand-child-form">
                            <form onSubmit={handleSubmit(addAdminProfile)}>
                                <div className="form-floating">
                                    <input
                                        name={strings.adminName}
                                        type="text"
                                        {...register("adminName", {
                                            required: strings.adminNameError,
                                            minLength: {
                                                value: 2,
                                                message: strings.minCharError
                                            },
                                            maxLength: 50,
                                           
                                            pattern: {
                                              value: constants.inputPattern.patternWithoutSpaceSecond,
                                              message: strings.alphabetsOnly,
                                            }
                                           
                                        })}
                                        className={errors.adminName ? "form-control validateEmail email-input pb-0 input-text-alert" : "form-control validateEmail email-input pb-0"}
                                        placeholder=" "
                                        autoComplete="off"
                                        defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.adminName) :""): ""}
                                    />
                                    <label htmlFor="floating-input" className="text-light input-place">
                                        {strings.adminName}
                                    </label>
                                    <div className="form-validation">
                                        <small>
                                            {errors.adminName && (
                                                <span>
                                                    <strong>&#9432;</strong>
                                                    {errors.adminName.message}
                                                </span>
                                            )}
                                        </small>
                                    </div>
                                </div>
                                <div className="form-floating">
                                    <input
                                        name={strings.email}
                                        type="email"
                                        {...register("email", {
                                            required: strings.adminEmailError,
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                message: strings.emailValidate
                                            }
                                        })}
                                        className={errors.email ? "form-control validateEmail email-input pb-0 input-text-alert" : "form-control validateEmail email-input pb-0"}
                                        placeholder=" "
                                        autoComplete="off"
                                        defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.email) :""): ""}
                                    />
                                    <label htmlFor="floating-input" className="text-light input-place">
                                        {strings.adminEmailAddress}
                                    </label>
                                    <div className="form-validation">
                                        <small>
                                            {errors.email && (
                                                <span>
                                                    <strong>&#9432;</strong>
                                                    {errors.email.message}
                                                </span>
                                            )}
                                        </small>
                                    </div>
                                </div>
                                <div className="form-floating">
                                    <input
                                        name={strings.adminEmployeeId}
                                        type="text"
                                        {...register("adminEmpId", {
                                            required: true,
                                            maxLength: {
                                                value: 30
                                            },
                                            pattern : {
                                              value: constants.inputPattern.patternWithoutSpaceThird,
                                              }
                                        })}
                                        className={errors.adminEmpId ? "form-control validateEmail email-input pb-0 input-text-alert" : "form-control validateEmail email-input pb-0"}
                                        placeholder=" "
                                        autoComplete="off"
                                        defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.adminEmpId) :""): ""}
                                    />
                                    <label htmlFor="floating-input" className="text-light input-place">
                                        {strings.adminEmployeeId}
                                    </label>
                                    <div className="form-validation">
                                        <small>
                                            {errors.adminEmpId && (
                                                <span>
                                                    <strong>&#9432;</strong>
                                                    {strings.adminEmpIdError}
                                                </span>
                                            )}
                                        </small>
                                    </div>
                                </div>
                                <div className="form-floating">
                                    <input
                                        name={strings.adminDesignation}
                                        type="text"
                                        {...register("adminDes", {
                                            required: strings.adminDesError,
                                            minLength: {
                                                value: 2,
                                                message: strings.minCharError
                                            },
                                            maxLength: 30,
                                            pattern: {
                                              value: constants.inputPattern.patternWithoutSpaceThird,
                                                message: strings.alphabetsOnly
                                            }
                                        })}
                                        className={errors.adminDes ? "form-control validateEmail email-input pb-0  input-text-alert" : "form-control validateEmail email-input pb-0"}
                                        placeholder=" "
                                        autoComplete="off"
                                        defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.adminDes) :""): ""}
                                    />
                                    <label htmlFor="floating-input" className="text-light input-place">
                                        {strings.adminDesignation}
                                    </label>
                                    <div className="form-validation">
                                        <small>
                                            {errors.adminDes && (
                                                <span>
                                                    <strong>&#9432;</strong>
                                                    {errors.adminDes.message}
                                                </span>
                                            )}
                                        </small>
                                    </div>
                                </div>
                                <div className="form-floating">
                                    <input
                                        name={strings.adminDepartment}
                                        type="text"
                                        {...register("adminDept", {
                                            required: strings.adminDeptError,
                                            minLength: {
                                                value: 2,
                                                message: strings.minCharError
                                            },
                                            maxLength: 50,
                                            pattern: {
                                              value: constants.inputPattern.patternWithoutSpaceSecond,
                                                message: strings.alphabetsOnly
                                            }
                                        })}
                                        className={errors.adminDept ? "form-control validateEmail email-input pb-0 input-text-alert" : "form-control validateEmail email-input pb-0"}
                                        placeholder=" "
                                        autoComplete="off"
                                        defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.adminDept) :""): ""}
                                    />
                                    <label htmlFor="floating-input" className="text-light input-place">
                                        {strings.adminDepartment}
                                    </label>
                                    <div className="form-validation">
                                        <small>
                                            {errors.adminDept && (
                                                <span>
                                                    <strong>&#9432;</strong>
                                                    {errors.adminDept.message}
                                                </span>
                                            )}
                                        </small>
                                    </div>
                                </div>
                                <div className="form-floating">
                                    <input
                                        type="date"
                                        {...register("adminJoiningDate", { required: true })}
                                        className={errors.adminJoiningDate ? "form-control validateEmail email-input pb-0 input-text-alert" : "form-control validateEmail email-input pb-0"}
                                        placeholder=" "
                                        autoComplete="off"
                                        data-date-inline-picker="true"
                                        max={moment().format("YYYY-MM-DD")}
                                        defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.adminJoiningDate) :""): ""}
                                    />
                                    <label htmlFor="floating-input" className="text-light input-place label-date">
                                        {strings.adminJoiningDate}
                                    </label>
                                    <div className="form-validation">
                                        <small>
                                            {errors.adminJoiningDate && (
                                                <span>
                                                    <strong>&#9432;</strong>
                                                    {strings.joiningDateError}
                                                </span>
                                            )}
                                        </small>
                                    </div>
                                </div>

                                <div className="form-floating">
                                  <input
                                    {...register("adminLoc", {
                                      required: strings.requiredAdminLoc,
                                      minLength: {
                                        value: 2,
                                        message: strings.minCharError,
                                      },
                                      maxLength: {
                                        value: 100,
                                        message: strings.maxLengthAddress,
                                      },
                                      pattern : {
                                        value: constants.inputPattern.patternWithoutSpaceThird,
                                        message : strings.errorLabel
                                        }
                                    })}
                                    type="text"
                                    className={
                                      errors.empID
                                      ? "form-control validateEmail email-input pb-0 input-text-alert" : "form-control validateEmail email-input pb-0"
                                    }
                                    name={strings.variableAdminLocation}
                                    
                                    defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.adminLoc) :""): ""}
                                    placeholder=" "
                                    autoComplete="off"
                                  />
                                  <label
                                    htmlFor="floating-input"
                                    className="text-light input-place"
                                  >
                                    {strings.adminLocation}
                                  </label>
                                  <div className="form-validation">
                                    <small>
                                      {errors.adminLoc && (
                                        <span>
                                          <strong className="mx-1">&#9432;</strong>
                                          {errors.adminLoc.message}
                                        </span>
                                      )}
                                    </small>
                                  </div>
                                </div>
                                <div className="form-floating contact-number">
                                  <input
                                    {...register("adminCon", {
                                      required: strings.validationContact,
                                      minLength: {
                                        value: 10,
                                        message: strings.numberError,
                                      },
                                      maxLength: {
                                        value: 10,
                                        message: strings.numberError,
                                      },
                                      
                                      
                                    })}
                                    type="number"
                                    className={
                                      errors.adminCon
                                      ? "form-control validateEmail email-input pb-0 input-text-alert" : "form-control validateEmail email-input pb-0"
                                    }
                                    name={strings.variableAdminContact}
                                    defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.adminCon) :""): ""}
                                    
                                    placeholder=" "
                                    autoComplete="off"
                                  />
                                  <label
                                    htmlFor="floating-input"
                                    className="text-light input-place"
                                  >
                                    {strings.contactNumber}
                                  </label>
                                  <div className="form-validation">
                                    <small>
                                      {errors.adminCon && (
                                        <span>
                                          <strong>&#9432;</strong>
                                          {errors.adminCon.message}
                                        </span>
                                      )}
                                    </small>
                                  </div>
                                </div>

                                <div className="form-floating">
                                    <input
                                        type="date"
                                        {...register(constants.constantRoles.adminDobLabel, { required: strings.adminDobError })}
                                        className={errors.adminDob ? "form-control validateEmail email-input pb-0 input-text-alert" : "form-control validateEmail email-input pb-0"}
                                        placeholder=" "
                                        autoComplete="off"
                                        data-date-inline-picker="true"
                                        max={moment().subtract(18, "years").format("YYYY-MM-DD")}
                                        defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.adminDob) :""): ""}

                                    />
                                    <label htmlFor="floating-input" className="text-light input-place label-date">
                                        {strings.adminDateOfBirth}
                                    </label>
                                    <div className="form-validation">
                                        <small>
                                            {errors.adminDob && (
                                                <span>
                                                    <strong>&#9432;</strong>
                                                    {errors.adminDob.message}
                                                </span>
                                            )}
                                        </small>
                                    </div>
                                </div>
              
                                <div className="form-floating">
                  <div className="mt-1 mb-1 text-light">
                    <label className="mt-1 select-box-label">
                      {strings.adminGender}
                    </label>
                    <select
                      {...register("adminGender", { required: true })}
                      className={
                        errors.adminGender
                          ? "bg-transparent error"
                          : "bg-transparent select-dropdown small-arrow"
                      }
                      name={strings.varAdminGender}
                   
                      defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.adminGender) :""): ""}
                    >
                      <option value="" disabled hidden> {strings.selectGender}
                      </option>
                      {strings.adminGenderList.map((key, index) => {
                        return (
                          <option id="dropdown-label" key={index} value={key}>
                            <p>{key}</p>
                          </option>
                        );
                      })}
                    </select>
                    <div className={"form-validation"}>
                      <small>
                        {errors.adminGender && (
                          <span>
                            <strong>&#9432;</strong>
                            {strings.maritalStatusValidation}
                          </span>
                        )}
                      </small>
                    </div>
                  </div>
                </div>

                                  <div className="form-floating">
                                <input
                                  {...register("adminNat", {
                                    required: true,
                                    minLength: {
                                      value: 2,
                                      message: strings.minCharError,
                                    },
                                    pattern : {
                                      value: constants.inputPattern.patternWithoutSpaceSecond,
                                      }
                                  })}
                                  type="text"
                                  className={
                                    errors.adminNat
                                    ? "form-control validateEmail email-input pb-0 input-text-alert" : "form-control validateEmail email-input pb-0"
                                  }
                                  name={strings.variableNationality}
                                  defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.adminNat) :""): ""}
                                  
                                  placeholder=" "
                                  autoComplete="off"
                                />
                                <label
                                  htmlFor="floating-input"
                                  className="text-light input-place"
                                >
                                  {strings.nationality}
                                </label>
                                <div className="form-validation">
                                  <small>
                                    {errors.adminNat && (
                                      <span>
                                        <strong>&#9432;</strong>
                                        {strings.errorNationality}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                              <div className="form-floating">
                                <input
                                  {...register("adminFath", {
                                    required: true,
                                    minLength: {
                                      value: 2,
                                      message: strings.minCharError,
                                    },
                                    pattern : {
                                      value: constants.inputPattern.patternWithoutSpaceSecond,
                                      }
                                  })}
                                  type="text"
                                  className={
                                    errors.adminFath
                                    ? "form-control validateEmail email-input pb-0 input-text-alert" : "form-control validateEmail email-input pb-0"
                                  }
                                  name={strings.variableFather}
                              
                                  defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.adminFath) :""): ""}
                                  placeholder=" "
                                  autoComplete="off"
                                />
                                <label
                                  htmlFor="floating-input"
                                  className="text-light input-place"
                                >
                                  {strings.fatherName}
                                </label>
                                <div className="form-validation">
                                  <small>
                                    {errors.adminFath && (
                                      <span>
                                        <strong>&#9432;</strong>
                                        {strings.errorFatherName}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                                <div className="form-floating">
                                  <div className="mt-1 mb-1 text-light">
                                    <label className="mt-1 select-box-label">
                                      {strings.maritalStatus}
                                    </label>
                                    <select
                                      {...register("maritalStatus", { required: true })}
                                      className={
                                        errors.maritalStatus
                                          ? "bg-transparent error"
                                          : "bg-transparent select-dropdown small-arrow"
                                      }
                                      name={strings.varMaritalStatus}
                                      defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.maritalStatus) :""): ""}
                                    >
                                      <option value="" disabled hidden> {strings.marital}</option>
                                      {strings.maritalStatusOption.map((key,index) => {
                                        return (
                                          <option id="dropdown-label" key={index} value={key}>
                                            <p>{key}</p>
                                          </option>
                                        );
                                      })}
                                    </select>
                                    <div className={"form-validation"}>
                                      <small>
                                        {errors.maritalStatus && (
                                          <span>
                                        
                                            <strong>&#9432;</strong>
                                            {strings.maritalStatusValidation}
                                          </span>
                                        )}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                         <div className="form-floating">
                                  <div className="mt-1 mb-1 text-light">
                                    <label className="mt-1 select-box-label">
                                      {strings.internationalEmployee}
                                    </label>
                                    <select
                                      {...register("internationalEmployee", { required: true })}
                                      className={
                                        errors.international
                                          ? "bg-transparent error"
                                          : "bg-transparent select-dropdown small-arrow"
                                      }
                                      name={strings.varInternationalEmp}
                                      defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.internationalEmployee) :""): ""}
                                    >
                                      <option value="" disabled hidden> {strings.selectInternational}</option>
                                      {strings.internationalEmployeeOption.map((key ,index) => {
                                        return (
                                          <option id="dropdown-label" key={index} value={key}>
                                            <p>{key}</p>
                                          </option>
                                        );
                                      })}
                                    </select>
                                    <div className={"form-validation"}>
                                      <small>
                                        {errors.internationalEmployee && (
                                          <span>
                                            <strong>&#9432;</strong>
                                            {strings.internationalEmployeeValidation}
                                          </span>
                                        )}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                         <div className="form-floating">
                                  <div className="mt-1 mb-1 text-light">
                                    <label className="mt-1 select-box-label">
                                      {strings.employmentType}
                                    </label>
                                    <select
                                      {...register("employment", { required: true })}
                                      className={
                                        errors.employment
                                          ? "bg-transparent error"
                                          : "bg-transparent select-dropdown small-arrow"
                                      }
                                      name={strings.employmentLabel}
                                      defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.employment) :""): ""}
                                    >
                                      <option value="" disabled hidden> {strings.selectEmploymentTypes}</option>
                                      {strings.employmentTypes.map((key,index) => {
                                        return (
                                          <option id="dropdown-label" key={index} value={key}>
                                            <p>{key}</p>
                                          </option>
                                        );
                                      })}
                                    </select>
                                    <div className="form-validation">
                                      <small>
                                        {errors.employment && (
                                          <span>
                                            <strong>&#9432;</strong>
                                            {strings.employmentValidation}
                                          </span>
                                        )}
                                      </small>
                                    </div>
                                  </div>
                                </div>

                                <div className="form-floating">
                                  <div className="mt-1 mb-1 text-light">
                                    <label className="mt-1 select-box-label">
                                      {strings.physicallyChallenged}
                                    </label>
                                    <select
                                      {...register("physically", { required: true })}
                                      className={
                                        errors.physically
                                          ? "bg-transparent error"
                                          : "bg-transparent select-dropdown small-arrow"
                                      }
                                      name={strings.varPhysicallyChallenged}
                                      defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.physically) :""): ""}
                                    >
                                     <option value="" disabled hidden> {strings.selectPhysical}</option>
                                      {strings.physicallyChallengedOption.map((key,index) => {
                                        return (
                                          <option id="dropdown-label" key={index} value={key}>
                                            <p>{key}</p>
                                          </option>
                                        );
                                      })}
                                    </select>
                                    <div className={"form-validation"}>
                                      <small>
                                        {errors.physically && (
                                          <span>
                                            <strong>&#9432;</strong>
                                            {strings.physicallyValidationValidation}
                                          </span>
                                        )}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                <div className="form-floating">
                                  <div className="mt-1 mb-1 text-light">
                                    <label className="mt-1 select-box-label">
                                      {strings.bloodGroup}
                                    </label>
                                    <select
                                      {...register("bloodGroup", { required: true })}
                                      className={
                                        errors.bloodGroup
                                          ? "bg-transparent error"
                                          : "bg-transparent select-dropdown small-arrow"
                                      }
                                      name={strings.varBloodGroup}
                                      defaultValue={adminFormData ?(adminFormData.data ? (adminFormData.data.bloodGroup) :""): ""}
                                    >
                                      <option value="" disabled hidden> {strings.selectBloodGroup}</option>
                                      {strings.bloodGroupOption.map((key,index) => {
                                        return (
                                          <option id="dropdown-label" key={index} value={key}>
                                            <p>{key}</p>
                                          </option>
                                        );
                                      })}
                                    </select>
                                    <div className={"form-validation"}>
                                      <small>
                                        {errors.bloodGroup && (
                                          <span>
                                            <strong>&#9432;</strong>
                                            {strings.bloodGroupValidation}
                                          </span>
                                        )}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-primary next-btn">
                                    <Ripple duration={1000} />
                                    {strings.loginBtn}
                                </button>
                            </form>
                        </div>
                    </div>
                </div >
            </div>
        </React.Fragment>
    )
}
